export default __webpack_public_path__ + "static/media/D-DIN.fd83e27a.otf";